// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__12KQ5","itemTitle":"ClientEmergencyInfo_itemTitle__36oF3","itemText":"ClientEmergencyInfo_itemText__jOZDR"};